<template>
  <span
    class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-green-100 text-green-700"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "SuccessBadge",
  props: ["label"],
};
</script>
